"use strict";
/**
 *  @internal
 *  @module Utils
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.missingKeys = exports.transformKeys = exports.isBlob = exports.toSnakeCase = exports.toCamelCase = void 0;
var tslib_1 = require("tslib");
var change_case_1 = require("change-case");
var is_buffer_1 = tslib_1.__importDefault(require("is-buffer"));
var toCamelCase = function (key) { return (0, change_case_1.camelCase)(key, { stripRegexp: /[^A-Z0-9.]/gi }); };
exports.toCamelCase = toCamelCase;
var toSnakeCase = function (key) { return (0, change_case_1.snakeCase)(key, { stripRegexp: /[^A-Z0-9.]/gi }); };
exports.toSnakeCase = toSnakeCase;
var isObject = function (value) { return typeof value === "object" && Boolean(value); };
var isBlob = function (data) {
    return isObject(data) &&
        typeof data.size === "number" &&
        typeof data.type === "string" &&
        typeof data.slice === "function";
};
exports.isBlob = isBlob;
var transformKeys = function (obj, transformer, ignoreKeys) {
    if (ignoreKeys === void 0) { ignoreKeys = []; }
    var transformArray = function (arr) {
        return arr.map(function (item) { return (isObject(item) ? (0, exports.transformKeys)(item, transformer, ignoreKeys) : item); });
    };
    if (Array.isArray(obj)) {
        return transformArray(obj);
    }
    var ignoredKeySet = new Set(ignoreKeys);
    return Object.keys(obj || {}).reduce(function (acc, key) {
        var _a;
        var value = obj[key];
        if (ignoredKeySet.has(key)) {
            return tslib_1.__assign(tslib_1.__assign({}, acc), (_a = {}, _a[key] = value, _a));
        }
        var shouldTransformKeys = isObject(value) && !(0, exports.isBlob)(value) && !(0, is_buffer_1.default)(value);
        var formattedValue = shouldTransformKeys ? (0, exports.transformKeys)(value, transformer, ignoreKeys) : value;
        acc[transformer(key)] = formattedValue;
        return acc;
    }, {});
};
exports.transformKeys = transformKeys;
/**
 * Returns a list from `keys` that are not found in `obj`
 */
var missingKeys = function (obj, keys) {
    var e_1, _a;
    if (keys === void 0) { keys = []; }
    if (!obj) {
        return keys;
    }
    var objKeys = Object.keys(obj);
    var missing = [];
    try {
        for (var keys_1 = tslib_1.__values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
            var key = keys_1_1.value;
            if (objKeys.indexOf(key) === -1 || obj[key] === undefined) {
                missing.push(key);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return missing;
};
exports.missingKeys = missingKeys;
//# sourceMappingURL=object.js.map